const MANAGE_API_KEY_ACTION_TYPE = {
  GET_API_LIST: "GET_API_LIST"
};

export default MANAGE_API_KEY_ACTION_TYPE;
